/** Gemeinsame Konstanten des Clickdummy-Exports (PHQ-109/110). */

/** Ziel des Kauf-Buttons. Der Shop-Link kommt später — dann nur diese Konstante ändern. */
export const SHOP_URL = 'https://rittec.de';

/** Hinweistext, wenn eine Funktion im Export nicht verfügbar ist. */
export const PURCHASE_NOTICE_TEXT = 'Diese Funktion ist im Export nicht verfügbar. Project HQ erhalten Sie bei Rittec.';

/** Zusatz, wenn der Nutzer speichern will (Änderungen gelten nur im Speicher). */
export const SAVE_NOTICE_LEAD = 'Änderungen gelten nur bis zum Schließen dieser Datei und werden nicht gespeichert.';

/** Beschriftung des Kauf-Buttons. */
export const PURCHASE_BUTTON_LABEL = 'Zu Rittec';

/** Name der Vorlage im Build-Ausgabeordner (`dist/`), relativ zur App-Wurzel. */
export const TEMPLATE_FILE = 'clickdummy-template.html';

/** Platzhalter in der Vorlage, an dessen Stelle das Daten-JSON-Skript tritt. */
export const DATA_PLACEHOLDER = '<!--PHQ_CLICKDUMMY_DATA-->';

/** id des `<script type="application/json">`-Elements mit der Nutzlast. */
export const DATA_ELEMENT_ID = 'phq-clickdummy-data';

/** Globaler Schlüssel am window (Netzwächter zählt dort blockierte Aufrufe). */
export const GLOBAL_KEY = '__PHQ_CLICKDUMMY__';

/** Schema-Version der Nutzlast. */
export const PAYLOAD_SCHEMA = 1;

/** Schalter für den Export-Button. Erst `true`, wenn der Export vollständig lauffähig ist. */
export const CLICKDUMMY_EXPORT_ENABLED = false;
